define.alias("shared/components/shared/mobile/drawer/carousel-card", "settings/components/shared/mobile/drawer/carousel-card");